// extracted by mini-css-extract-plugin
module.exports = {"image":"ItemHeaderMobile-image-047f"};